export default __webpack_public_path__ + "static/m-fitness4-7b62ab86bd486d2351c6a4b0d70a92cd.jpg";